module.exports = __webpack_public_path__ + "static/avatar-eaa22784ace9c29fa683f9298f1e59c8.jpg";